// src/redux/api/public/gifts.ts

import { publicApi } from './index';

// Types for the public gift API
export interface PublicGift {
  id: string;
  network: string;
  message?: string;
  imageUrl?: string;
  status: string;
  htlcExpiry?: string;
  token?: string;
  baseToken?: string;
  creator: {
    id: string;
    email: string;
  };
  receiver?: {
    id: string;
    email: string;
  } | null;
}

export interface PublicGiftResponse {
  gift: PublicGift;
  canClaim: boolean;
}

export const publicGiftsApi = publicApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Query to get public gift information.
     * Sends a GET request to /api/public/gifts/:giftId
     * Returns public gift data that can be viewed by non-authenticated users.
     */
    getPublicGift: builder.query<PublicGiftResponse, string>({
      query: (giftId) => `/public/gifts/${giftId}`,
    }),
  }),
  overrideExisting: true,
});

// Export hooks for usage in functional components
export const { useGetPublicGiftQuery, useLazyGetPublicGiftQuery } =
  publicGiftsApi;
